function wizardButtonDirective(action) {
    return function () {
        return {
            restrict: 'A',
            require: '^olyWizard',
            link(scope, element, attrs, wizard) {
                element.on('click', function (e) {
                    e.preventDefault();
                    scope.$apply(wizard[action]);
                });
            }
        };
    };
}

module.exports = {
    next: wizardButtonDirective('next'),
    previous: wizardButtonDirective('previous'),
    finish: wizardButtonDirective('finish'),
    cancel: wizardButtonDirective('cancel'),
    restart: wizardButtonDirective('restart')
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/wizard/wizard-buttons-directive.js
 **/